import { useMemo } from 'react'

import { Subscription } from '@infura/packages.api'
import { KSService } from '@infura/packages.common/servicePlan'
import { getUserSubscriptionTier } from '@infura/packages.common/user'
import { ServiceTier } from '@infura/packages.uks'

import { getTierByProductHandle } from 'lib/utils/billing'

/**
 * useCurrentTier gets the tier from the users Maxio subscription if chargify billing enabled.
 * Otherwise it gets it from the users servicePlan
 **/
export const useCurrentTier = (subscription: Subscription | null, servicePlan?: KSService) => {
  return useMemo<ServiceTier>(() => {
    // to account for chargify webhook-uks update delay, we use chargify subscription to get the updated data
    if (subscription) {
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      return getTierByProductHandle(subscription?.product?.handle)
    }

    return getUserSubscriptionTier(servicePlan)
  }, [subscription, servicePlan])
}
